/**
 * Font utilities for managing font loading
 */

import { getStaticDomain } from './aem-utils';

/**
 * Checks if a specific SkyHeadline font face is already defined in the document head
 * If not found, appends the font face definition
 * @return {boolean} True if font was appended, false if it was already present
 */
export const ensureSkyHeadlineFont = () => {
  const staticDomain = getStaticDomain();

  // Font face definition to check for and potentially add
  const fontFaceDefinition = `
@font-face {
    font-family: SkyHeadline;
    font-style: normal;
    font-weight: 500;
    font-display: swap;
    src: url(${staticDomain}/libs/sky-aem-frontend/clientlibs/dp_base/css/resources/fonts/SkyHeadline_W_SBd.woff2) format("woff2");
}
`;

  // Function to check if the font face already exists in a stylesheet
  const fontFaceExists = () => {
    const styleSheets = document.styleSheets;

    // Loop through all stylesheets
    for (let i = 0; i < styleSheets.length; i++) {
      try {
        const cssRules = styleSheets[i].cssRules || styleSheets[i].rules;

        // Loop through all CSS rules in the stylesheet
        for (let j = 0; j < cssRules.length; j++) {
          const rule = cssRules[j];

          // Check if it's a font-face rule for SkyHeadline with weight 500
          if (
            rule.constructor.name === 'CSSFontFaceRule' &&
            rule.style.fontFamily.includes('SkyHeadline') &&
            rule.style.fontWeight === '500' &&
            rule.style.src.includes('SkyHeadline_W_SBd.woff2')
          ) {
            return true;
          }
        }
      } catch (e) {
        // Skip cross-origin stylesheets that can't be read due to CORS
        continue;
      }
    }

    return false;
  };

  // Check if the font face already exists
  if (!fontFaceExists()) {
    // Create new style element
    const styleElement = document.createElement('style');
    styleElement.appendChild(document.createTextNode(fontFaceDefinition));

    // Append to head
    document.head.appendChild(styleElement);
    return true;
  }

  return false;
};
